export const REQUIRED_PERMISSION = 'app.access';
